import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { SolutionOption as SolutionOptionModel } from '../../../core/models/solution.model';

/**
 * Tarjeta de una solución dentro del modal de cambio de solución. Réplica de
 * `app-workspace-option` en modo `switch`: pinta el logo de la solución cuando lo hay y,
 * si no, el icono del catálogo.
 */
@Component({
  selector: 'app-solution-option',
  standalone: true,
  imports: [MatIconModule, TranslateModule],
  templateUrl: './solution-option.html',
  styleUrl: './solution-option.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SolutionOption {
  solution = input.required<SolutionOptionModel>();
  selected = input<boolean>(false);

  selectSolution = output<SolutionOptionModel>();

  /**
   * Url que no cargó. Se guarda la url y no un booleano para que la tarjeta vuelva sola al
   * logo si le entra otra solución, sin tener que limpiar nada al cambiar de entrada.
   */
  private failedLogoUrl = signal<string | null>(null);

  /** Logo propio de la solución —hoy solo el Dashboard trae uno—; si no, el icono. */
  protected logoUrl = computed<string | null>(() => {
    const url = this.solution().imageUrl;
    return url && url !== this.failedLogoUrl() ? url : null;
  });

  /** Una solución sin destino conocido se muestra, pero no se puede elegir. */
  protected isSelectable = computed<boolean>(() => !this.solution().isCurrent && !!this.solution().url);

  protected badgeLabel = computed<string>(() =>
    this.solution().isCurrent ? 'Solución actual' : (this.solution().url ? 'Disponible' : 'No disponible')
  );

  /** Una imagen rota deja la tarjeta vacía: mejor volver al icono del catálogo. */
  protected onLogoError(): void {
    this.failedLogoUrl.set(this.solution().imageUrl);
  }

  protected onSelect(): void {
    if (!this.isSelectable()) return;
    this.selectSolution.emit(this.solution());
  }
}
